import { Component, Input } from '@angular/core';
import { CompanyLogoConfiguration } from 'src/app/models/auxiliary/company-logo-configuration';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-correspondences-list-report',
  templateUrl: './correspondences-list-report.component.html',
  styleUrls: ['./correspondences-list-report.component.scss']
})
export class CorrespondencesListReportComponent {


  @Input() reportId: string;
  @Input() data: [];
  @Input() isEntry: boolean;
  companyLogo: CompanyLogoConfiguration = null;

  date= new Date();
  constructor(public commonDataService: CommonDataService) {
    this.companyLogo = new CompanyLogoConfiguration();
  }
  ngOnInit() {
    this.commonDataService.getCompanyLogo().subscribe((labConfiguration: CompanyLogoConfiguration) => {
      this.companyLogo = labConfiguration;
    });
  }
}
